import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchSuggestionDetails,
  clearSuggestionDetails,
  selectData,
  selectIsLoading,
  selectSelectedSuggestion,
  selectSuggestionDetails,
  selectDetailsLoading,
  selectResponseType,
  fetchData,
  selectSuggestionsLoading,
  fetchSuggestions,
  setSuggestions,
  selectSuggestionsError,
  resetState,
  setChatbotId,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
  selectOpenAiTokens,
} from "../../../../mainApp/features/DataSlice/dataSlice";
import {
  ChatbotContainer,
  ChatbotMain,
  ChatbotDetailsPanel,
  ChatbotForm,
  ChatbotTextarea,
  ChatbotButton,
  ChatbotExpandButton,
  ChatbotDetailsHeader,
  ChatbotError,
  ChatbotSuggestions,
  SuggestionsHeader,
  SuggestionsBox,
  SuggestionItem,
  SuggestionTitle,
  ChatbotDetails,
  ChatbotMessage,
  AppTitle,
  LoadingElement,
  DocumentTypeSelector,
} from "../styled";
import LoadingPage from "../../TechnicalTabs/LoadingPage";
import ErrorPage from "../../../../mainApp/features/TechnicalTabs/ErrorPage";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { handleUnauthorizedAccess } from "../../Utility/handleUnauthorizedAccess";
import { ARTICLE_TITLES_COST, ARTICLE_CONTENT_COST } from "../../Utility/tokenCosts";

const ArticlesChatbot = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const suggestionsError = useSelector(selectSuggestionsError);
  const suggestions = useSelector(selectData);
  const selectedSuggestion = useSelector(selectSelectedSuggestion);
  const suggestionDetails = useSelector(selectSuggestionDetails);
  const detailsLoading = useSelector(selectDetailsLoading);
  const responseType = useSelector(selectResponseType);
  const currentTokens = useSelector(selectOpenAiTokens);

  const [topic, setTopic] = useState("");
  const [writerStyle, setWriterStyle] = useState("");
  const [articleType, setArticleType] = useState("");
  const [articleGenre, setArticleGenre] = useState("");
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [openAiTokens, setOpenAiTokensState] = useState(0);

  const validationToastId = 'articles-bot-validation-toast';

  // Opcje dla list rozwijanych
  const writerStyles = [
    { value: "", label: "Wybierz styl pisarza" },
    { value: "Thomas Sowell", label: "Thomas Sowell" },
    { value: "Zadie Smith", label: "Zadie Smith" },
    { value: "Jia Tolentino", label: "Jia Tolentino" },
    { value: "Malcolm Gladwell", label: "Malcolm Gladwell" },
    { value: "Jerzy Pilch", label: "Jerzy Pilch" },
    { value: "Douglas Murray", label: "Douglas Murray" },
    { value: "Christopher Hitchens", label: "Christopher Hitchens" },
    { value: "Mariusz Szczygieł", label: "Mariusz Szczygieł" },
    { value: "Marcin Wicha", label: "Marcin Wicha" },
    { value: "George Orwell", label: "George Orwell" }
  ];

  const articleTypes = [
    { value: "", label: "Wybierz rodzaj artykułu" },
    { value: "artykuł do bloga", label: "Artykuł do bloga" },
    { value: "artykuł do czasopisma", label: "Artykuł do czasopisma" },
    { value: "artykuł do serwisu informacyjnego", label: "Artykuł do serwisu informacyjnego" },
    { value: "artykuł na uczelnię", label: "Artykuł na uczelnię" },
    { value: "artykuł naukowy", label: "Artykuł naukowy" }
  ];

  const articleGenres = [
    { value: "", label: "Wybierz gatunek artykułu" },
    { value: "felieton", label: "Felieton" },
    { value: "komentarz", label: "Komentarz" },
    { value: "recenzja", label: "Recenzja" },
    { value: "esej", label: "Esej" },
    { value: "rozprawka", label: "Rozprawka" }
  ];

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    dispatch(setChatbotId("articles"));
    dispatch(clearSuggestionDetails());
    dispatch(resetState());
    dispatch(fetchData());

    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          dispatch(fetchData());
          const ref = doc(db, "Users", currentUser.uid);
          const snap = await getDoc(ref);
          if (!snap.exists()) {
            console.warn("Dokument użytkownika nie istnieje.");
          }
          await delay(600);
        } catch (error) {
          console.error("Błąd pobierania danych użytkownika:", error);
          await delay(600);
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  useEffect(() => {
    if (restrictedDataError) {
      navigate("/unauthorized");
    }
  }, [restrictedDataError, navigate]);

  useEffect(() => {
    if (currentTokens !== openAiTokens) {
      setOpenAiTokensState(currentTokens);
    }
  }, [currentTokens]);

  const handleTopicChange = (e) => setTopic(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!topic.trim()) {
      dispatch(setSuggestions("Proszę podać temat artykułu."));
      return;
    }
    if (!writerStyle) {
      dispatch(setSuggestions("Proszę wybrać styl pisarza."));
      return;
    }
    if (!articleType) {
      dispatch(setSuggestions("Proszę wybrać rodzaj artykułu."));
      return;
    }
    if (!articleGenre) {
      dispatch(setSuggestions("Proszę wybrać gatunek artykułu."));
      return;
    }

    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < ARTICLE_TITLES_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować tytuły.", toastOptions);
      return;
    }

    dispatch(fetchSuggestions());
    dispatch({ 
      type: "FETCH_ARTICLE_TITLES", 
      payload: { topic, writerStyle, articleType, articleGenre } 
    });
    dispatch(clearSuggestionDetails());
  };

  const handleSuggestionClick = (index) => {
    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < ARTICLE_CONTENT_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować treść artykułu.", toastOptions);
      return;
    }

    if (selectedSuggestion === index) {
      dispatch(clearSuggestionDetails());
    } else {
      dispatch(fetchSuggestionDetails({
        index,
        topic,
        writerStyle,
        articleType,
        articleGenre
      }));
    }
  };

  const toggleDetailsPanel = () => setIsDetailsExpanded((prev) => !prev);

  if (initialLoading || isLoading === "loading") {
    return <LoadingPage />;
  }

  let returned;

  switch (isLoading) {
    case "success":
      if (!user) {
        returned = <LoadingPage />;
      } else if (tilesDetails.length > 0 && user) {
        returned = (
          <ChatbotContainer>
            <ChatbotMain isDetailsPanelVisible={selectedSuggestion !== null} isDetailsExpanded={isDetailsExpanded}>
              <AppTitle>Generator Artykułów</AppTitle>
              
              <ChatbotForm onSubmit={handleSubmit} isArticles>
                <div>
                  <DocumentTypeSelector
                    value={writerStyle}
                    onChange={(e) => setWriterStyle(e.target.value)}
                  >
                    {writerStyles.map((style) => (
                      <option key={style.value} value={style.value}>
                        {style.label}
                      </option>
                    ))}
                  </DocumentTypeSelector>

                  <DocumentTypeSelector
                    value={articleType}
                    onChange={(e) => setArticleType(e.target.value)}
                  >
                    {articleTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </DocumentTypeSelector>

                  <DocumentTypeSelector
                    value={articleGenre}
                    onChange={(e) => setArticleGenre(e.target.value)}
                  >
                    {articleGenres.map((genre) => (
                      <option key={genre.value} value={genre.value}>
                        {genre.label}
                      </option>
                    ))}
                  </DocumentTypeSelector>

                  <ChatbotButton type="submit" disabled={suggestionsLoading} tokenCost={ARTICLE_TITLES_COST}>
                    {suggestionsLoading ? "Generowanie..." : "Generuj tytuły"}
                  </ChatbotButton>
                </div>

                <ChatbotTextarea
                  value={topic}
                  onChange={handleTopicChange}
                  placeholder="Wprowadź temat artykułu..."
                  isArticles
                />
              </ChatbotForm>

              {suggestionsLoading ? (
                <LoadingElement>Ładowanie</LoadingElement>
              ) : suggestionsError ? (
                <ChatbotError>{suggestionsError}</ChatbotError>
              ) : suggestions && responseType === "message" ? (
                <ChatbotMessage>{suggestions}</ChatbotMessage>
              ) : Array.isArray(suggestions) && responseType === "suggestions" ? (
                <ChatbotSuggestions>
                  <SuggestionsHeader>Propozycje tytułów artykułów:</SuggestionsHeader>
                  <SuggestionsBox>
                    {suggestions.map((suggestion, index) => (
                      <SuggestionItem
                        key={index}
                        onClick={() => handleSuggestionClick(index)}
                        style={{
                          backgroundColor: selectedSuggestion === index ? "#1db954" : undefined,
                        }}
                        tokenCost={ARTICLE_CONTENT_COST}
                      >
                        <SuggestionTitle>{suggestion.title}</SuggestionTitle>
                      </SuggestionItem>
                    ))}
                  </SuggestionsBox>
                </ChatbotSuggestions>
              ) : (
                <ChatbotMessage>Brak tytułów lub wystąpił błąd.</ChatbotMessage>
              )}
            </ChatbotMain>

            <ChatbotDetailsHeader isDetailsExpanded={isDetailsExpanded} />
            <ChatbotExpandButton
              onClick={toggleDetailsPanel}
              isDetailsExpanded={isDetailsExpanded}
            >
              {isDetailsExpanded ? "Zwiń szczegóły" : "Rozwiń szczegóły"}
            </ChatbotExpandButton>

            <ChatbotDetailsPanel isDetailsExpanded={isDetailsExpanded}>
              {selectedSuggestion !== null && suggestions.length > 0 ? (
                detailsLoading ? (
                  <LoadingElement>Generowanie artykułu...</LoadingElement>
                ) : suggestionDetails ? (
                  <ChatbotDetails>
                    <h2>{suggestions[selectedSuggestion].title}</h2>
                    {suggestionDetails.split("\n").map((line, i) => (
                      <p key={i}>{line}</p>
                    ))}
                  </ChatbotDetails>
                ) : (
                  <ChatbotError isLawyerDetails>
                    Przeciążenie sieci. Spróbuj ponownie za kilka minut.
                  </ChatbotError>
                )
              ) : (
                <ChatbotMessage>Wybierz tytuł, aby wygenerować artykuł.</ChatbotMessage>
              )}
            </ChatbotDetailsPanel>
          </ChatbotContainer>
        );
      } else {
        returned = handleUnauthorizedAccess();
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default ArticlesChatbot;